<template>
  <nuxt-picture
    :alt="alt || ''"
    quality="75"
    :background="background"
    :src="image.hash"
    :modifiers="{ ...(shouldTrim && { trim: 1 }), brightness, format: 'webp' }"
    :sizes="sizes"
    :loading="hasPriority ? 'eager' : 'lazy'"
    :fetchpriority="hasPriority ? 'high' : 'low'"
    :img-attrs="{ fetchpriority: hasPriority ? 'high' : 'low' }"
    class="picture block"
    :style="{ aspectRatio }"
    :class="{
      'picture-contain': fit === 'contain',
      'picture-cover picture-height': fit === 'cover',
      'picture-width': isPdp,
    }"
    data-test-id="product-image"
  />
</template>

<script setup lang="ts">
import { getAttributeValue, type ProductImage } from '@scayle/storefront-nuxt'

type ProductImageProps = {
  sizes?: string
  image: ProductImage
  shouldTrim?: boolean
  fit?: string
  isCentered?: boolean
  alt?: string
  aspectRatio?: string
  isPdp?: boolean
  lowPriority?: boolean
}

const props = withDefaults(defineProps<ProductImageProps>(), {
  sizes: '',
  shouldTrim: false,
  fit: 'contain',
  isCentered: false,
  alt: '',
  aspectRatio: '7/10',
  isPdp: false,
  lowPriority: false,
})

const viewportPriority = useViewportPriority()

const hasPriority = computed(() => {
  return viewportPriority.hasPriority.value && !props.lowPriority
})

const brightness = computed(() => {
  const background = getAttributeValue(
    props.image?.attributes,
    'imageBackground',
  )
  if (background === 'white') {
    return 0.96
  } else if (background === 'grey') {
    return 1.06
  }
  return 1
})

const background = computed(() => {
  const background = getAttributeValue(
    props.image?.attributes,
    'imageBackground',
  )

  if (background === 'transparent') {
    return 'F4F4F4'
  } else {
    return 'FFFFFF'
  }
})
</script>
